// extracted by mini-css-extract-plugin
export default {"item":"styles_item__70wwv","icon":"styles_icon__aNkgL","tooltipIcon":"styles_tooltipIcon__2GKK5"};